"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInferredState = exports.predictExhaustSync = exports.predictExhaust = exports.getRemainingPercentage = exports.getUsagePercentage = exports.getConsumedPercentage = exports.isRecalled = exports.isExpiredSync = exports.isExpired = exports.isExpirable = exports.isNearlySpent = exports.isSpent = exports.isExpendable = exports.isNearlyDepleted = exports.isDepleted = exports.isDepletable = exports.Recallable = exports.Expirable = exports.Expendable = exports.Depletable = exports.ExhaustUnpredictableError = void 0;
const effect_1 = require("effect");
const Depletable = __importStar(require("./depletable"));
const Expendable = __importStar(require("./expendable"));
const Expirable = __importStar(require("./expirable"));
var common_1 = require("./common");
Object.defineProperty(exports, "ExhaustUnpredictableError", { enumerable: true, get: function () { return common_1.ExhaustUnpredictableError; } });
exports.Depletable = __importStar(require("./depletable"));
exports.Expendable = __importStar(require("./expendable"));
exports.Expirable = __importStar(require("./expirable"));
exports.Recallable = __importStar(require("./recallable"));
var depletable_1 = require("./depletable");
Object.defineProperty(exports, "isDepletable", { enumerable: true, get: function () { return depletable_1.isDepletable; } });
Object.defineProperty(exports, "isDepleted", { enumerable: true, get: function () { return depletable_1.isDepleted; } });
Object.defineProperty(exports, "isNearlyDepleted", { enumerable: true, get: function () { return depletable_1.isNearlyDepleted; } });
var expendable_1 = require("./expendable");
Object.defineProperty(exports, "isExpendable", { enumerable: true, get: function () { return expendable_1.isExpendable; } });
Object.defineProperty(exports, "isSpent", { enumerable: true, get: function () { return expendable_1.isSpent; } });
Object.defineProperty(exports, "isNearlySpent", { enumerable: true, get: function () { return expendable_1.isNearlySpent; } });
var expirable_1 = require("./expirable");
Object.defineProperty(exports, "isExpirable", { enumerable: true, get: function () { return expirable_1.isExpirable; } });
Object.defineProperty(exports, "isExpired", { enumerable: true, get: function () { return expirable_1.isExpired; } });
Object.defineProperty(exports, "isExpiredSync", { enumerable: true, get: function () { return expirable_1.isExpiredSync; } });
var recallable_1 = require("./recallable");
Object.defineProperty(exports, "isRecalled", { enumerable: true, get: function () { return recallable_1.isRecalled; } });
exports.getConsumedPercentage = effect_1.Match.type().pipe(effect_1.Match.when(Depletable.isDepletable, Depletable.getLevelPercentage), effect_1.Match.when(Expendable.isExpendable, Expendable.getUsagePercentage), effect_1.Match.exhaustive);
exports.getUsagePercentage = exports.getConsumedPercentage;
const getRemainingPercentage = (consumable) => 1 - (0, exports.getConsumedPercentage)(consumable);
exports.getRemainingPercentage = getRemainingPercentage;
/**
 * Predict the {@link DateTime.DateTime DateTime} the consumable is expected to exceed the `rangeExhaust`,
 * assuming the current rate of usage is maintained
 */
exports.predictExhaust = effect_1.Effect.fn('predictExhaust')(function* (consumable) {
    return yield* effect_1.Match.value(consumable).pipe(effect_1.Match.when(Depletable.isDepletable, Depletable.predictExhaust), effect_1.Match.when(Expendable.isExpendable, Expendable.predictExhaust), effect_1.Match.exhaustive);
});
/**
 * See {@link predictExhaust}
 */
const predictExhaustSync = (...args) => effect_1.Effect.runSync((0, exports.predictExhaust)(...args));
exports.predictExhaustSync = predictExhaustSync;
exports.getInferredState = effect_1.Effect.fn('getInferredState')(function* (slot) {
    const expirableProps = yield* effect_1.Option.liftPredicate(slot, Expirable.isExpirable).pipe(effect_1.Option.match({
        onSome: slot => effect_1.Effect.all({ expired: Expirable.isExpired(slot) }).pipe(effect_1.Effect.map(effect_1.Option.some)),
        onNone: () => effect_1.Effect.succeed(effect_1.Option.none()),
    }));
    const depletableProps = effect_1.Option.liftPredicate(slot, Depletable.isDepletable).pipe(effect_1.Option.map(slot => ({
        depleted: Depletable.isDepleted(slot),
        nearlyDepleted: Depletable.isNearlyDepleted(slot),
    })));
    const expendableProps = effect_1.Option.liftPredicate(slot, Expendable.isExpendable).pipe(effect_1.Option.map(slot => ({
        spent: Expendable.isSpent(slot),
        nearlySpent: Expendable.isNearlySpent(slot),
    })));
    const propsArray = effect_1.Array.getSomes([
        expirableProps,
        depletableProps,
        expendableProps,
    ]);
    return propsArray.reduce((acc, props) => ({ ...acc, ...props }), {});
});
//# sourceMappingURL=index.js.map